// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    CHECKING_ACCOUNT_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    E_ACCOUNT_LOAN_PRODUCT_ALIAS,
} = require('constants/hiringProductInformation');
const {
    ACCOUNT_TYPE_JUNIOR,
    ACCOUNT_TYPE_E_LOAN,
    CHECKING_ACCOUNT,
    CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT,
    CONTRACT_INDEX_PAYROLL_ACCOUNT,
    CONTRACT_INDEX_DEPOSIT_EXPIRATION
} = require('constants/index');
const { MAIN_DEPOSIT } = require('constants/hiringProductInformation');

const pollingDocumentsTimeout = {
    request: null
}

const resetPreContractualPolling = () => {
    clearTimeout(pollingDocumentsTimeout.request)
    return {
        type: actionTypes.PRE_CONTRACTUAL_POLLING_RESET,
    }
};

const preContractualPollingInitRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_INIT_REQUEST,
});

const preContractualPollingInitSuccess = (operationProcessId) => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_INIT_SUCCESS,
    payload:
        {
            operationProcessId,
        }
});

const preContractualPollingInitFailure = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_INIT_FAILURE,
});

const preContractualPollingDocumentsRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_DOCUMENTS_REQUEST,
});

const preContractualPollingDocumentsSuccess = (documents = [], allDocuments = []) => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_DOCUMENTS_SUCCESS,
    payload: {
        documents,
        allDocuments
    }
});

const preContractualPollingDocumentsFailure = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_DOCUMENTS_FAILURE,
});

const preContractualDocumentationListRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_DOCUMENTATION_LIST_REQUEST,
});

const preContractualDocumentationListSuccess = (documents = []) => ({
    type: actionTypes.PRE_CONTRACTUAL_DOCUMENTATION_LIST_SUCCESS,
    payload: {
        documents
    }
});

const preContractualDocumentationListFailure = () => ({
    type: actionTypes.PRE_CONTRACTUAL_DOCUMENTATION_LIST_FAILURE,
});


const preContractualRawDocumentRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_RAW_DOCUMENT_REQUEST,
});

const preContractualRawDocumentSuccess = (file, dmsDocumentId) => ({
    type: actionTypes.PRE_CONTRACTUAL_RAW_DOCUMENT_SUCCESS,
    payload: {
        file,
        dmsDocumentId
    }
});

const preContractualRawDocumentFailure = () => ({
    type: actionTypes.PRE_CONTRACTUAL_RAW_DOCUMENT_FAILURE,
});


const preContractualPollingMailRequest = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_MAIL_REQUEST,
});

const preContractualPollingMailSuccess = (operationProcessId) => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_MAIL_SUCCESS,
    payload:
        {
            operationProcessId,
        }
});

const preContractualPollingMailFailure = () => ({
    type: actionTypes.PRE_CONTRACTUAL_POLLING_MAIL_FAILURE,
});


const precontractualDocumentationAdapter = (currentDocumentList) => (
    currentDocumentList.map(document => {
        return {
            documentName: document,
            dmsDocumentType: document,
            isAccepted: false,
            isRead: false
        }
    })
)

const insertPrecontractualDocumentationIdAdapter = (currentDocumentList, doctments) => (
    currentDocumentList.map(currentDocument => {
        const document = doctments.find(document => document.documentType === currentDocument.documentName) || {}
        return {
            ...currentDocument,
            dmsDocumentId: document.dmsDocumentId,
            documentChecksum: document.checksum
        }
    })
)

const sendPreContractualPollingMail = (current_contract, operationProcessId, name = null) => (dispatch, getState) => {
    const isMailSent = getState().preContractualPolling.getIn(['mail', 'sent']);
    const {
        product,
        standard,
        subtype,
        title,
        type,
        productAlias,
    } = current_contract;
    const productName = name ? formatText(name) : formatText(title);

    let precontractualMailProductInfo = {
        productName,
        producto: type,
        standard,
        subproducto: subtype,
        ...(productAlias && { productAlias: productAlias })
    };

    let precontractualMailProductInfoRelated = [{
        productAlias: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    }];

    //If its Payroll Account but not an Upgrade To Payroll Account
    if (!!current_contract.accountAlias && current_contract.accountAlias === 'payroll_account' && !current_contract.onlyUpgradeableToPayroll) {
        precontractualMailProductInfo.productsRelated = precontractualMailProductInfoRelated;
    } else if ([CHECKING_ACCOUNT_PRODUCT_ALIAS, E_ACCOUNT_LOAN_PRODUCT_ALIAS].includes(product)) {
        precontractualMailProductInfo = {
            productAlias: product,
            productName,
        };

        if (product === CHECKING_ACCOUNT_PRODUCT_ALIAS) {
            precontractualMailProductInfo.productsRelated = precontractualMailProductInfoRelated;
        }
    }

    if (!isMailSent){
        dispatch(preContractualPollingMailRequest());
        const requestData = {
            query: {
                ...precontractualMailProductInfo,
                operationProcessId,
            },
            header: {
                version: 2,
            }
        };
        return APIPost({
            dispatch,
            endpoint: 'sendPrecontractualDocumentMail',
            params: requestData
        })
        .then(() => dispatch(preContractualPollingMailSuccess()))
        .catch(() => dispatch(preContractualPollingMailFailure()))
    }
};

const getPreContractualDocumentationList = (processType) => (dispatch, getState) => {
    dispatch(preContractualDocumentationListRequest());

    const contractWizard = getState().contracts
    const isDeposit = contractWizard.get('contract_type') === MAIN_DEPOSIT

    const request = {
        query: {
            processType,
            originCountry: getState().profile.get('originCountry'),
            ...(
                isDeposit ? {
                    processorMetadataType: 'COMPOSITE_DMS'
                }
                : {}
            ),
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('precontractualDocumentationList'), request)
        .then(response => {
            const { documents } = response;
            const documentsList = precontractualDocumentationAdapter(documents);
            dispatch(preContractualDocumentationListSuccess(documentsList));
        })
        .catch(() => dispatch(preContractualDocumentationListFailure())); 
}

const getPrecontractualPDFDocument = (dmsDocumentId) => (dispatch) => {
    dispatch(preContractualRawDocumentRequest())

    return APIGet(dispatch, apiURLBuilder.getURL('rawDocument', { dmsDocumentId }), {
        header: {
            version: 2
        }
    })
        .then(response => {
            dispatch(preContractualRawDocumentSuccess(response.file, dmsDocumentId))
        })
        .catch(() => {
            dispatch(preContractualRawDocumentFailure())
        });
}

const getPreContractualPollingDocuments = (counterLoop = 0, endProcessCallback) => (dispatch, getState) => {
    dispatch(preContractualPollingDocumentsRequest());
    const operationProcessId = getState().preContractualPolling.get('operationProcessId');
    const contractName = getState().contracts.get('name_contract')

    return APIGet(dispatch, apiURLBuilder.getURL('precontractualPollingDocuments', { operationProcessId }))
    .then(response => {
        const { operationProcessStatus, documents: allDocuments } = response;
        if (operationProcessStatus === 'ERROR') {
            dispatch(preContractualPollingDocumentsFailure());
        } else if (operationProcessStatus === 'PENDING') {
            if (counterLoop > 15) {
                dispatch(preContractualPollingDocumentsFailure());
            } else {
                pollingDocumentsTimeout.request = setTimeout(() => dispatch(getPreContractualPollingDocuments(counterLoop + 1, endProcessCallback)), 2000);
            }
        } else if (['DOCUMENTS_COMPLETED', 'COMPLETED'].includes(operationProcessStatus)){
            if ([ACCOUNT_TYPE_JUNIOR, ACCOUNT_TYPE_E_LOAN, CHECKING_ACCOUNT, CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT, CONTRACT_INDEX_PAYROLL_ACCOUNT, CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractName)) {
                const currentDocumentList = getState().preContractualPolling.getIn(['documentation', 'documents'], []).toJS()
                const documentList = insertPrecontractualDocumentationIdAdapter(currentDocumentList, allDocuments)

                const promises = documentList.map(document => dispatch(getPrecontractualPDFDocument(document.dmsDocumentId, documentList, endProcessCallback)))

                dispatch(preContractualPollingDocumentsSuccess(documentList, allDocuments))
                Promise.all(promises)
                return
            }
            dispatch(preContractualPollingDocumentsSuccess())
        }
    })
    .catch(() => dispatch(preContractualPollingDocumentsFailure()));
}

const preContractualPollingInitialization = (
    product,
    id = undefined,
    url = undefined,
    endProcessCallback = undefined,
    extraData = {}
) => (dispatch) => {
    dispatch(preContractualPollingInitRequest());
    const requestData = {
        query: {
            processType: product,
            ...(!!id && { 
                metadata: {
                    dmsDocumentId: id,
                    ...extraData
                }
            }),
            ...(!!url && { 
                metadata: {
                    precontractualDocumentUrl: url,
                    ...extraData
                }
            }),
        }
    };
    return APIPost(
        dispatch,
        apiURLBuilder.getURL("precontractualPollingInit"),
        requestData
    )
        .then(response => {
            dispatch(preContractualPollingInitSuccess(response.operationProcessId))
            dispatch(getPreContractualPollingDocuments(0, endProcessCallback))
        })
        .catch(() => dispatch(preContractualPollingInitFailure()))
};

module.exports = {
    preContractualPollingInitialization,
    resetPreContractualPolling,
    sendPreContractualPollingMail,
    getPreContractualDocumentationList,
};
